var Marionette = require('marionette')
var _ = require('lodash')

// -- select filter
var FilterMultiSelectItem = Marionette.View.extend({
  template: require('../templates/filter-multi-select-item.html'),
  tagName: 'li',

  onRender: function () {
    if (this.model.get('selected')) {
      this.el.classList.add('is-selected')
    } else {
      this.el.classList.remove('is-selected')
    }
  },
  events: {
    'click': function (event) {
      this.model.set('selected', !this.model.get('selected'))
    }
  },
  modelEvents: {
    'change': 'render'
  }
})

var FilterMultiSelect = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: FilterMultiSelectItem,
  className: 'filter-popup__list',
  collectionEvents: {
    'add': 'collectionChange'
  },
  collectionChange: function () {
    this.trigger('updated', {})
  }
})
module.exports = FilterMultiSelect



// WEBPACK FOOTER //
// ./js/components/devices-filter/views/filter-multi-select.js